import './CustomerLogin.scss'

import { Tab, Tabs } from '@tallink/components-lib'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'

import { selectClubOneTab, selectCompanyTab } from '../../../actions/actions'
import {
  isClubOneLogged,
  isClubOneTabSelected,
  isCompanyCustomerLogged,
  isCompanyTabSelected
} from '../../../selectors/selectors'
import ClubOne from './ClubOneCustomer/ClubOneCustomer'
import CompanyCustomer from './CompanyCustomer/CompanyCustomer'

function TabSelector() {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const companyCustomerLogged = useSelector(isCompanyCustomerLogged)
  const clubOneTabSelected = useSelector(isClubOneTabSelected)
  const companyTabSelected = useSelector(isCompanyTabSelected)

  return (
    <Tabs>
      <Tab
        className="client-type-tab"
        disabled={companyCustomerLogged}
        onClick={() => dispatch(selectClubOneTab())}
        selected={clubOneTabSelected}
      >
        {t('clubOne.title')}
      </Tab>
      <Tab className="client-type-tab" onClick={() => dispatch(selectCompanyTab())} selected={companyTabSelected}>
        {t('companyCustomer.title')}
      </Tab>
    </Tabs>
  )
}

function TabContent() {
  const clubOneTabSelected = useSelector(isClubOneTabSelected)

  return clubOneTabSelected ? <ClubOne /> : <CompanyCustomer handleBackButtonClick={() => {}} />
}

export default function CustomerLogin() {
  const clubOneLogged = useSelector(isClubOneLogged)

  return (
    <section className="serial-tickets-client-types">
      {!clubOneLogged && <TabSelector />}
      <TabContent />
    </section>
  )
}
